(function () {
    const url = sessionStorage.getItem('restore_url');

    if (url) {
        sessionStorage.removeItem('restore_url');

        if (window.location.href !== url) {
            window.location.replace(url);
        }
    }
})();